import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { captureAttribution } from './utils/attribution';

// Antes do render: o router ainda não mexeu na URL de entrada (UTMs/gclid intactos).
captureAttribution();

const container = document.getElementById('root');


const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Verifica se o container já tem elementos dentro (HTML pré-gerado pelo react-snap)
if (container.hasChildNodes()) {
  // Se sim, apenas "hidrata" o HTML, adicionando os eventos de clique e interatividade
  hydrateRoot(container, app);
} else {
  // Se não (ex: quando estás a programar no npm start), renderiza tudo do zero
  const root = createRoot(container);
  root.render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
